<template>
  <div>
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          icon
          v-bind="attrs"
          v-on="on"
          :loading="laedt"
          :disabled="laedt"
          @click.stop="downloadReport"
        >
          <v-icon>
            mdi-download
          </v-icon>
        </v-btn>
      </template>
      <span>Report als PDF herunterladen</span>
    </v-tooltip>

    <v-snackbar v-model="fehler" :timeout="4000" color="error">
      Report konnte nicht erzeugt werden.
    </v-snackbar>
  </div>
</template>

<script>
export default {
  name: "Sirene_Download",
  props: ["sirene"],
  data: () => ({
    laedt: false,
    fehler: false,
  }),
  methods: {
    dateinameAusHeader(header) {
      if (!header) return null;
      const treffer = /filename\*?=(?:UTF-8'')?"?([^";]+)"?/i.exec(header);
      return treffer ? decodeURIComponent(treffer[1]) : null;
    },
    ersatzDateiname() {
      return (
        "Sirenenreport_" +
        this.sirene.name_safus +
        "_" +
        this.sirene.name +
        ".pdf"
      );
    },
    // Der Store-Action "update" ruft auf jede Antwort response.text() und
    // JSON.parse und kann daher kein Blob transportieren - deshalb hier ein
    // eigener fetch.
    async downloadReport() {
      this.laedt = true;
      try {
        const antwort = await fetch(
          this.$store.state.general.api_host +
            "/sirenen/" +
            this.sirene.id +
            "/report",
          {
            headers: {
              Authorization: "Bearer " + this.$store.state.user.authToken,
            },
          }
        );
        if (!antwort.ok) {
          throw new Error("HTTP " + antwort.status);
        }
        const blob = await antwort.blob();
        const name =
          this.dateinameAusHeader(antwort.headers.get("Content-Disposition")) ||
          this.ersatzDateiname();

        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = name;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      } catch (e) {
        console.error("[Sirene_Download] Report fehlgeschlagen:", e);
        this.fehler = true;
      } finally {
        this.laedt = false;
      }
    },
  },
};
</script>

<style scoped>
</style>
